import { Notification } from '../notification';

export interface NotificationState {
  /**
   * Gets an array containing the current notifications.
   */
  notifications: Notification[];

  /**
   * A valid indicating whether or not the notifications panel is open.
   */
  isPanelOpen: boolean;
}

export const getDefaultNotificationState = (): NotificationState => ({
  notifications: [],
  isPanelOpen: false,
});
